import React from 'react';
import {WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

// 显示条数
class EShowNum extends React.Component {
    state = {
        value: this.props.value
    };

    render() {
        return (
            <WeaFormItem label={getLabel(19493, '显示条数')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaInput value={this.state.value} style={{width: '100px'}} onChange={value => this.setState({value: value})}/>
            </WeaFormItem>
        );
    }

    getSaveValues() {
        return this.state.value;
    }
}

export default EShowNum;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/EShowNum.js